// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-loading/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springLoadingEN: PageEntry = {
  id: "post.federbelastung",
  locale: "en",
  slug: "spring-loading",
  seo: {
    title: "Glossary: Spring loading explained simply | Dietz GmbH",
    description: "The spring load refers to the forces or loads that act on a spring and deform it. In mechanical systems, springs are often used as elements for storing and transmitting energy. The",
  },
  type: "post",
  h1: "Glossary: Spring loading explained simply",
  intro: "The spring load refers to the forces or loads that act on a spring and deform it. In mechanical systems, springs are often used as elements for storing and transmitting energy. The correct spring load is crucial for the proper functioning of a system. Engineers take into account various factors such as the duration of the load, the type of load and the maximum permissible deformation of the spring. Precisely calculating and analysing the spring load leads to an optimal spring design for different applications.",
  blocks: [

  ],
};
